// Starts a guided tour (#160) from anywhere: startTour("basics").
const START_EVENT = "khronos:start-tour";
const seenKey = (id) => `khronos_tour_${id}`;

export const startTour = (id = "basics") =>
  window.dispatchEvent(new CustomEvent(START_EVENT, { detail: { id } }));

export const onStartTour = (handler) => {
  const listener = (e) => handler(e.detail?.id || "basics");
  window.addEventListener(START_EVENT, listener);
  return () => window.removeEventListener(START_EVENT, listener);
};

export const hasSeenTour = (id) => {
  try {
    return localStorage.getItem(seenKey(id)) === "1";
  } catch {
    return false;
  }
};

export const markTourSeen = (id) => {
  try {
    localStorage.setItem(seenKey(id), "1");
  } catch {
    /* storage disabled: nothing remembers it, which is harmless */
  }
};
